module.exports = __webpack_public_path__ + "img/precursor-logo-849x250px.dcb52a11.png";